/**
 * @generated SignedSource<<0fb164ee3d5f3c8dfbdcc677e67d83f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserLogoutMutation$variables = Record<PropertyKey, never>;
export type UserLogoutMutation$data = {
  readonly UserLogout: {
    readonly error: string | null | undefined;
    readonly success: string | null | undefined;
  } | null | undefined;
};
export type UserLogoutMutation = {
  response: UserLogoutMutation$data;
  variables: UserLogoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "input",
        "value": {}
      }
    ],
    "concreteType": "UserLogoutPayload",
    "kind": "LinkedField",
    "name": "UserLogout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": "UserLogout(input:{})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserLogoutMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserLogoutMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8a5b053718c7beb320807535f372d84b",
    "id": null,
    "metadata": {},
    "name": "UserLogoutMutation",
    "operationKind": "mutation",
    "text": "mutation UserLogoutMutation {\n  UserLogout(input: {}) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa53874aea0e7ec3d786a9a07497049c";

export default node;
